import { jsxs as o, jsx as m } from "react/jsx-runtime";
import a from "react";
import { match as n } from "ts-pattern";
import { DiscountChip as c } from "../DiscountChip/DiscountChip.js";
const p = function (r, i) {
  let e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  return n(r).with({
    type: "waitlist"
  }, t => t.waitlistLabel).with({
    type: "price"
  }, t => t.formattedAmount).with({
    type: "discounted"
  }, t => /* @__PURE__ */o(a.Fragment, {
    children: [/* @__PURE__ */m(c, {
      inverted: e,
      lineThrough: !0,
      background: i,
      children: t.formattedOriginalAmount
    }), " ", t.formattedAmount]
  })).exhaustive();
};
export { p as formatPrice };